//@flow
import * as React from 'react'
import type { ContainerRowInstructionLink$Props } from './flowTypes'

const addOrgFileSuffix=(docUrl:string)=>{
    if (docUrl.indexOf(".test")>0){
        return docUrl.replace(".test",".test/org.files")
    } else if (docUrl.indexOf(".quali")>0){
        return docUrl.replace(".quali",".quali/org.files")
    } else if (docUrl.indexOf(".prod")>0){
        return docUrl.replace(".prod",".prod/org.files")
    }
    return ""
}

const getOrgSrcLink=(docUrl:string)=>{
    if (docUrl.indexOf("static.gigsdata.com")>0){
        let newUrl = addOrgFileSuffix(docUrl)
        if (newUrl && newUrl.indexOf("-Page")>0){
            const sourceExt = newUrl.substring(newUrl.lastIndexOf("."))
            newUrl=newUrl.substring(newUrl.indexOf("-Page"),0).concat(sourceExt)
            return newUrl
        }
        return newUrl
    }

    return ""
}

const ContainerRowInstructionLink=(props:ContainerRowInstructionLink$Props)=>{
    const orgSrcLink = getOrgSrcLink(props.docLink)
    
    return (
        <div className="row">
            <div className="col-sm">
                <a href={props.instructionLink} target='_blank' >Instructions</a>
                &nbsp;&nbsp;&nbsp;
                <a href={props.docLink} target='_blank' >PDF Link</a>
                &nbsp;&nbsp;&nbsp;
                {orgSrcLink?<a href={orgSrcLink} target='_blank' >Original PDF Link</a>:null} 
                <br />
                <br />
            </div>
        </div> 
    )
}

export default ContainerRowInstructionLink


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowInstructionLink.js